import { useBeforeUnload as useRouterBeforeUnload } from "react-router-dom";

const useBeforeUnload = (handler: (event: BeforeUnloadEvent) => any) => {
  useRouterBeforeUnload(handler);

  // TODO: Also handle blocking navigation
};

export default useBeforeUnload;
